module.exports = __webpack_public_path__ + "fromBrideToMother-jp-w.04a520d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-jp-w.jpg
// module id = 3pWm
// module chunks = 0